import apolloClient from '../../apolloClient';
import resolutionsMutation from 'src/gql/mutations/resolution';

const createResolution = async (variables) =>
  apolloClient.mutate({
    mutation: resolutionsMutation.CREATE_RESOLUTION,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateResolutionById = async (variables) =>
  apolloClient.mutate({
    mutation: resolutionsMutation.UPDATE_RESOLUTION_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteResolutionById = async (variables) =>
  apolloClient.mutate({
    mutation: resolutionsMutation.DELETE_RESOLUTION_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  updateResolutionById,
  createResolution,
  deleteResolutionById,
};
